namespace $ {
	export let $bog_bzrl_app_gap = {
		...$mol_gap,
		roundMore: $mol_style_func.vary('--mol_gap_roundMore'),
	} as const
}
